"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBalanceLogRecordTypeToBadgeMultiSelectItem = void 0;
const mapBalanceLogRecordTypeToBadgeMultiSelectItem = (item) => ({
    value: item.code,
    name: item.name,
});
exports.mapBalanceLogRecordTypeToBadgeMultiSelectItem = mapBalanceLogRecordTypeToBadgeMultiSelectItem;
//# sourceMappingURL=utils.js.map